import { AnalysisRequirementItem } from 'modules/analyse/types/AnaylsisRequirementItem';

export const findParentAnalysisRequirementId = (
  analysisRequirementId: string,
  analysisRequirements: AnalysisRequirementItem[]
) => {
  const analysisRequirement = analysisRequirements.find(
    (analysisRequirement) => analysisRequirement.id === analysisRequirementId
  );

  return analysisRequirement?.parentAnalysisRequirementId;
};
